module.exports = __webpack_public_path__ + "img/pluto73.add0dd96.jpg";